import React from 'react';

const CheckMarkSVG = props => (
	<svg width="12" height="12" viewBox="0 0 12 12" stroke="#444" strokeWidth="2" fill="none" {...props}>
		<path d="m2,7 2.6,3 5.6-8"/>
	</svg>
);

export default CheckMarkSVG;
